import { GameTypeAbstract } from "../constants/gameTypes/GameTypeAbstract";

export class TournamentResultVO {
    public name: string;
    public rank: number = 0;
    public chips: number = NaN;
    public gold: number = NaN;
    public tournamentPoints: number = 0;

    /** e.g. tournament or sitngo **/
    public gameType: GameTypeAbstract;

    // texts
    public txtRank: string;
    public txtTitle: string;
    public txtCopy: string;

    public toString(): string {
        return "name: " + this.name + ", rank: " + this.rank + ", chips: " + this.chips + ", gold: " + this.gold + ", tp: " + this.tournamentPoints + ", gameType: " + this.gameType + ", txtRank: " + this.txtRank + ", txtTitle: " + this.txtTitle + ", txtCopy: " + this.txtCopy;
    }
}
